module.exports = __webpack_public_path__ + "img/hr-cargo-wagon-2.577fb67a.png";